import { useTranslation } from 'react-i18next';
import React from 'react';
import H6 from '../../components/Titles/h6';
import FullWidthImage from '../../components/Images/image-full-width';
import Select from '../../components/Inputs/select';
import { useCart } from '../../contexts/cart-context';

export default function CardProductCart({ product }) {
    const { t, i18n } = useTranslation();
    const { cart, updateCart } = useCart();

    const getQuantity = (p) => {
        const index = cart.findIndex(
            (c) => c.slug === p.slug && c.reference === p.modelProduct[0].reference
        );
        if (index === -1) return 1;
        return cart[index].quantity;
    };

    const numberOptions = () => {
        const max = Number(product.modelProduct[0].quantity) || 1;
        return Array.from({ length: max }, (_, index) => ({
            value: `${index + 1}`,
            label: `${index + 1}`,
        }));
    };

    const handleSelectChangeQuantity = (event) => {
        const quantity = Number(event.target.value);
        updateCart({
            slug: product.slug,
            reference: product.modelProduct[0].reference,
            quantity,
        });
    };

    const productName =
        (product.name && product.name[i18n.language]) ||
        (product.name && product.name.fr) ||
        '';

    const unitPrice = Number(product.modelProduct[0].priceTTC) || 0;
    const formattedPrice = `${unitPrice.toFixed(2)}€`;

    return (
        <div className="flex gap-3 px-2 py-4">
            <FullWidthImage
                url={product.imageSrc}
                alt={t('shop.alt') + productName}
                className="bg-white"
                customHeight={150}
                customWidth={150}
            />

            <div className="flex flex-1 justify-between items-stretch">
                {/* Infos produit */}
                <div className="flex flex-col justify-between text-left w-full">
                    <div className="flex flex-col gap-2">
                        <span className="text-xl font-bold">{formattedPrice}</span>
                        <H6 title={productName} fontWeight="light" />
                    </div>

                    {/* Bloc quantité avec meilleure visibilité */}
                    <div className="mt-2 flex items-center gap-3">
                        <span className="text-xs text-gray-500 uppercase tracking-wide">
                            {t('cart.quantityLabel')}
                        </span>
                        <div className="min-w-[90px] md:min-w-[110px] flex-shrink-0">
                            <Select
                                label={t('cart.quantityLabel')}
                                options={numberOptions()}
                                value={String(getQuantity(product))} // au cas où Select attend une string
                                onChange={handleSelectChangeQuantity}
                                displayLabel={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}